// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"e288487cdf0112ffb4b3","873":"5a3e7e597bf3d062b217"}[chunkId] + ".js";
};